export const EVENT_TYPE = {
  ERROR: 'error',
  OPEN: 'open',
  COLSED: 'colsed',
  CONNECTING: 'connecting',
}
